import * as React from 'react'

const SvgSprkPlus = (props) => {
  const { color } = props
  return (
    <svg viewBox='0 0 44 44' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M1 22C1 10.4 10.4 1 22 1s21 9.4 21 21-9.4 21-21 21S1 33.6 1 22Zm1.518 0A19.443 19.443 0 0 0 22 41.482 19.443 19.443 0 0 0 41.482 22 19.443 19.443 0 0 0 22 2.518 19.443 19.443 0 0 0 2.518 22Zm28.536-1.258v-2.926h-2.46v2.926h-2.886v2.403h2.887v3.03h2.459v-3.03h2.994v-2.403h-2.994Zm-20.257 1.15c0-2.359 1.896-4.271 4.235-4.271 2.34 0 4.237 1.912 4.237 4.271 0 2.36-1.897 4.272-4.237 4.272s-4.235-1.912-4.235-4.272Zm-1.185-5.455c-.183 0-.236.152-.074.244l1.227.7c.684.417.18 1.038.18 1.038a5.49 5.49 0 0 0-1.268 3.516c0 3.037 2.451 5.498 5.474 5.498 3.022 0 5.473-2.461 5.473-5.498 0-3.037-2.45-5.498-5.473-5.498H9.612Zm7.962 6.682c-.468 0-.847-.568-.847-1.269 0-.7.38-1.268.847-1.268.468 0 .847.568.847 1.268 0 .7-.379 1.27-.847 1.27Zm-2.88.508c-.655 0-1.186-.795-1.186-1.777 0-.98.53-1.776 1.186-1.776.655 0 1.186.795 1.186 1.776 0 .982-.531 1.777-1.186 1.777Z'
        fill={color || '#FFF'}
        fillRule='nonzero'
      />
    </svg>
  )
}

export default SvgSprkPlus
